import React from "react";

import { css } from "@emotion/css";
import {
  desktop,
  laptop,
  tablet,
} from "../../../styles/breakpoints";
import Phones from "../../../img/png/tech/phones-download.png";
import { Link } from "react-router-dom";
import buttons from "../../../styles/buttons";
import { useI18n } from "../../../i18n";

const Download = () => {
  const { t } = useI18n();
  return (
    <div className={style.container}>
      <img src={Phones} alt="" className="phones-image" />
      <h3>{t("tech_download_waiting")}</h3>
      <h2>{t("tech_download_join")}</h2>
      <h2>{t("tech_download_tribe")}</h2>
        <div className="apps">
          <Link
            className={`${buttons.primary}`}
            to={"/subscribe"}
          >
            {t("home_join_waitlist")}
          </Link>
        </div>
    </div>
  );
};

const style = {
  container: css({
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    background:
      "linear-gradient(180deg, #FAD5CD 14.84%, #FFF3E6 74.43%, #FFF 96.42%), #FFD5FA",
    paddingTop: 200,
    paddingBottom: 200,
    overflow: "hidden",

    h2: {
      color: "#000",
      fontFamily: "Syne",
      fontSize: 130,
      fontStyle: "normal",
      fontWeight: 700,
      lineHeight: "129.695px",
      display: "flex",
      gap: 30,
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
    },
    h3: {
      color: "#121212",
      textAlign: "center",
      fontFamily: "Syne",
      fontSize: 38,
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "51.84px",
      letterSpacing: "-0.38px",
      opacity: 0.4,
    },
    ".phones-image": {
      height: "auto",
      width: "1100px",
      marginBottom: 80,
    },
    ".apps": {
      display: "flex",
      gap: 15,
      flexDirection: "row",
      flexWrap: "nowrap",
      alignContent: "center",
      justifyContent: "center",
      alignItems: "center",
      marginTop: 20,

      img: {
        height: "auto",
        width: "167px",
      },
    },

    [desktop]: {
      paddingTop: 150,
      paddingBottom: 150,

      h2: {
        fontSize: 100,
        lineHeight: "112px",
      },
      h3: {
        fontSize: 40,
        lineHeight: "44.768px",
        letterSpacing: "-0.4px",
        marginBottom: 15,
      },
      ".phones-image": {
        height: "auto",
        width: "880px",
        marginBottom: 40,
      },
      ".apps": {
        gap: 15,

        img: {
          width: "132px",
        },
      },
    },
    [laptop]: {
      paddingTop: 150,
      paddingBottom: 150,

      h2: {
        fontSize: 70,
        lineHeight: "81.6px",
        gap: "5px !important",
      },
      h3: {
        fontSize: 25,
        lineHeight: "32.622px",
        letterSpacing: "-0.25px",
        marginBottom: 15,
      },
      ".phones-image": {
        width: "725px",
        marginBottom: 40,
      },
      ".apps": {
        gap: 5,

        img: {
          width: "104px",
        },
      },
    },
    [tablet]: {
      paddingTop: 50,
      paddingBottom: 100,

      h2: {
        fontSize: 53,
        lineHeight: "57.5px",
        gap: "5px !important",
        display: "flex",
        flexDirection: "column",
        flexWrap: "nowrap",
        alignContent: "center",
        justifyContent: "center",
        alignItems: "center",
      },
      h3: {
        fontSize: 18,
        lineHeight: "normal",
        letterSpacing: "-0.18px",
        marginBottom: 10,
      },
      ".phones-image": {
        width: "376px",
        marginBottom: 26,
      },
      ".apps": {
        gap: 5,

        img: {
          width: "80px",
        },
      },
    },
  }),
};

export default Download;
